import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})
export class AdminService {
    constructor(private httpClient: HttpClient) { }

    getAddressDetail(): Observable<any> {
        return this.httpClient.get('api/address/fetchAllStreets').pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    updateAddressDetail(data): Observable<any> {
        return this.httpClient.post('api/address/edit', { data })
            .pipe(map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            }));
    }

    createAddressDetail(data): Observable<any> {
        return this.httpClient.post('api/address/create',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }

    deleteAddressDetail(data): Observable<any> {
        return this.httpClient.post('api/address/remove',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }


    createUserRoles(data): Observable<any> {
        return this.httpClient.post('/api/address/create',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }


    getRole(): Observable<any> {
        return this.httpClient.get('/api/role/getRole').pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    updateRole(data): Observable<any> {
        return this.httpClient.post('/api/role/updateRole', { data })
            .pipe(map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            }));
    }

    fetchAllUserRoles(): Observable<any> {
        return this.httpClient.get('api/user/fetchAllUserRoles').pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }


    createUserWithRoles(data): Observable<any> {
        return this.httpClient.post('api/user/createUserRole',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }

    updateUserWithRoles(data): Observable<any> {
        return this.httpClient.post('api/user/updateUserRole',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }


    deleteRoleDetail(data): Observable<any> {
        return this.httpClient.post('api/user/remove',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }


    getAllVillageStaff(): Observable<any> {
        return this.httpClient.get('api/user/fetchAllVillageStaffRoles').pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }


    getOfficerStaff(): Observable<any> {
        return this.httpClient.get('api/user/fetchAllOfficerRoles').pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    updateReasonDetail(data): Observable<any> {
        return this.httpClient.post('api/reasons/edit', { data })
            .pipe(map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            }));
    }

    createReasonDetail(data): Observable<any> {
        return this.httpClient.post('api/reasons/create',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }

    deleteReasonDetail(data): Observable<any> {
        return this.httpClient.post('api/reasons/remove',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }

    getYearCycle(): Observable<any> {
        return this.httpClient.get('api/years/fetchAllYears').pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    getAllYearCycles(): Observable<any> {
        return this.httpClient.get('api/years/getAllYearCycles').pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    createcycleForYear(data): Observable<any> {
        return this.httpClient.post('api/years/createYear',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                }));
    }

    addCycles(data) {
        return this.httpClient.post('api/years/addCycles',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                }));
    }

    updateViolationAction(data): Observable<any> {
        return this.httpClient.post('api/violationaction/edit', { data })
            .pipe(map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            }));
    }

    createViolationAction(data): Observable<any> {
        return this.httpClient.post('api/violationaction/create',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }

    getCycles(): Observable<any> {
        return this.httpClient.get('api/cycles/fetchAllCycles').pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    deleteYear(data): Observable<any> {
        return this.httpClient.post('api/years/deleteYear',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    deleteCycle(data): Observable<any> {
        return this.httpClient.post('api/years/deleteCycle',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    updateYearCycle(data): Observable<any> {
        return this.httpClient.post('api/years/updateYearCycle',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }
    updateCycles(data): Observable<any> {
        return this.httpClient.post('api/years/updateCycles',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    deleteViolationAction(data): Observable<any> {
        return this.httpClient.post('api/violationaction/remove',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }

    updateIndexs(data): Observable<any> {
        return this.httpClient.post('api/violationaction/updateIndex',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }

    updateParkingReasonIndexs(data): Observable<any> {
        return this.httpClient.post('api/parkingReason/updateIndex',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }


    updateYearDetail(data): Observable<any> {
        return this.httpClient.post('api/years/edit', { data })
            .pipe(map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            }));
    }

    createYearDetail(data): Observable<any> {
        return this.httpClient.post('api/years/create',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }

    deleteYearDetail(data): Observable<any> {
        return this.httpClient.post('api/years/remove',
            { data })
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }


}